import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { CognitoService } from './cognito.service';


@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {

    static tokenKey:string = 'icFirmaDigialToken';
    private currentTokenSubject: BehaviorSubject<string>;

    constructor(private http: HttpClient, private cognitoService: CognitoService ) {
        this.currentTokenSubject = new BehaviorSubject<string>(JSON.parse(localStorage.getItem(AutenticacionService.tokenKey)));
    }

    public get currentTokenValue(): string {
        return this.currentTokenSubject.value;
    }

    public estaAutenticado(): boolean {
        return this.obtenerToken() != null;
    }
    
    public obtenerToken(): string {
        return sessionStorage.getItem(AutenticacionService.tokenKey); 
    }

    public salir() {
        sessionStorage.removeItem(AutenticacionService.tokenKey);
    }
  
    public ingresarToken(token: string): void {
        sessionStorage.setItem(AutenticacionService.tokenKey, token);
    }
}
